import Alpine from "alpinejs";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "lazysizes";

gsap.registerPlugin(ScrollTrigger);

window.Alpine = Alpine;

const initHorizontalGalleryScroll = () => {
	if (typeof window === "undefined") {
		return;
	}

	const galleries = document.querySelectorAll("[data-scroll-gallery]");
	if (!galleries.length) {
		return;
	}

	galleries.forEach((section) => {
		const viewport = section.querySelector("[data-scroll-viewport]") || section;
		const track = section.querySelector("[data-scroll-track]");

		if (!viewport || !track) {
			return;
		}

		const getDistance = () => track.scrollWidth - viewport.clientWidth;
		if (getDistance() <= 0) {
			return;
		}

		const horizontalScroll = gsap.to(track, {
			x: () => -getDistance(),
			ease: "none",
		});

		const trigger = ScrollTrigger.create({
			trigger: section,
			start: "top top",
			end: () => {
				return "+=" + getDistance();
			},
			pin: true,
			scrub: true,
			anticipatePin: 1,
			invalidateOnRefresh: true,
			animation: horizontalScroll,
		});

		section.addEventListener("refreshGalleryScroll", () => {
			trigger.refresh();
		});
	});
};

const initImageSliders = () => {
	const sliders = document.querySelectorAll(".swiper-images");
	if (!sliders.length) return;

	sliders.forEach((slider) => {
		const wrapper = slider.closest("[data-slider-wrapper]") || slider;
		const slideCount = slider.querySelectorAll(".swiper-slide").length;

		new Swiper(slider, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 24,
			loop: slideCount > 1,
			centeredSlides: slideCount === 1,
			navigation: {
				nextEl: wrapper.querySelector(".swiper-button-next"),
				prevEl: wrapper.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: wrapper.querySelector(".swiper-pagination"),
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: Math.min(2, slideCount),
				},
				1024: {
					slidesPerView: Math.min(3, slideCount),
				},
			},
		});
	});
};

const initWhenReady = () => {
	initHorizontalGalleryScroll();
	initImageSliders();
	ScrollTrigger.refresh();
};

if (document.readyState === "complete") {
	initWhenReady();
} else {
	window.addEventListener("load", initWhenReady);
}

window.addEventListener("resize", () => {
	ScrollTrigger.refresh();
});

Alpine.start();
